/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Form from 'forms/_.extend';
import Loading from 'components/Loading/Loading';
import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';
import StartAuditForm from './StartAuditForm/StartAuditForm';
import StartAuditSuccess from './StartAuditSuccess/StartAuditSuccess';
import StartAuditError from './StartAuditError/StartAuditError';

import styles from '../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  location: Object,
  accountId: string,
  type: string,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class StartAuditByLocations extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, location }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'startAudit',
        label: t('actionDrawer:Location'),
        fields: [
          {
            name: 'location',
            label: t('actionDrawer:location'),
            rules: '',
            value: location,
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { location }: Object = data.values().startAudit;

        actionDrawerStore.startAuditByLocations({
          id: location.id,
          company_id: location.company_id,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'startAudit',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, location, accountId, type }: TypeProps = this.props;

    const title: string = t(`actionDrawer:Start Audit by ${type}`);

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} disableCloseButton={true} />
          <StartAuditError location={location} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} disableCloseButton={true} />
          <StartAuditSuccess
            location={location}
            response={actionDrawerStore.response}
            type={type}
          />
        </div>
      );
    }

    return (
      <div className={`${styles['action-drawer-form']} ${styles.success}`}>
        <ActionDrawerHeader title={title} disableCloseButton={true} />
        <StartAuditForm
          location={location}
          accountId={accountId}
          form={this.createForm()}
          type={type}
        />
      </div>
    );
  }
}
